var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilebluesvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 38,
    viewBox: "0 0 34 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.54285 11.6547H21.4065V13.8339H5.54285V11.6547Z",
    fill: "#4B57E7",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5782 7.29602H21.4046V9.4753H14.5782V7.29602Z",
    fill: "#4B57E7",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.54285 16.0132H21.4065V18.1925H5.54285V16.0132Z",
    fill: "#4B57E7",
    fillOpacity: 0.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.54285 20.3717H21.4065V22.551H5.54285V20.3717Z",
    fill: "#4B57E7",
    fillOpacity: 0.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.54285 24.7303H12.0858V26.9096H5.54285V24.7303Z",
    fill: "#4B57E7",
    fillOpacity: 0.8
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0617 21.2113V0H4.81235L0 4.81235V37.193H25.972C30.3987 37.193 34 33.5917 34 29.1651C33.9999 25.108 30.9747 21.7448 27.0617 21.2113ZM5.17404 2.72017V5.40839H2.4859L5.17404 2.72017ZM2.17928 34.9752V7.58766H7.35339V2.17928H24.8824V21.2113C20.9694 21.7448 17.9441 25.108 17.9441 29.1651C17.9441 31.4484 18.9023 33.5121 20.4376 34.9752H2.17928ZM25.972 35.0137C22.7471 35.0137 20.1234 32.39 20.1234 29.1651C20.1234 25.9401 22.7471 23.3164 25.972 23.3164C29.197 23.3164 31.8207 25.9401 31.8207 29.1651C31.8207 32.39 29.1969 35.0137 25.972 35.0137Z",
    fill: "#4B57E7",
    fillOpacity: 0.8
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0605 25.8055H24.8813V28.0755H22.6113V30.2548H24.8813V32.5247H27.0605V30.2548H29.3305V28.0755H27.0605V25.8055Z",
    fill: "#4B57E7",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilebluesvg);
export default __webpack_public_path__ + "static/media/filebluesvg.c58158db2bc2317afc33cb05e5c66dc8.svg";
export { ForwardRef as ReactComponent };